import classNames from "classnames";
import React from "react";

import { IQuickSearchItem } from "../models.interfaces";

const QuickSearchItem = (props: IQuickSearchItem) => {
    const navClasses = classNames({
        "quicksearch__nav-item": true,
        "al-store-locator__nav-item--quicksearch": true,
        "quicksearch__nav-item--selected": props.selected,
    });

    return (
        <div className={navClasses}>
            <a
                className={`quicksearch__nav-button ${props.labelClassName}`}
                href={props.href}
            >
                <div className="quicksearch__nav-img-wrapper">
                    {/* TODO(i18n): Image alt text should be translated if it contains user-facing content. Verify imgAlt prop source and wrap in t`...` if needed */}
                    <img
                        className="quicksearch__nav-img"
                        alt={props.imgAlt}
                        src={props.imgSrc}
                    />
                </div>
                {/* TODO(i18n): Title should be translated if it's a string. Verify title prop source and wrap in t`...` if needed */}
                <h4 className="quicksearch__nav-title">{props.title}</h4>
            </a>
            {/* TODO(i18n): Description should be translated if it's a string. Verify descr prop source and wrap in t`...` if needed */}
            <div className="quicksearch__nav-descript">{props.descr}</div>
        </div>
    );
};

interface ILocatorQuickSearchComponentProps {
    items: IQuickSearchItem[];
    selectedItem: string | undefined;
}

export const LocatorQuickSearch = (
    props: ILocatorQuickSearchComponentProps,
) => {
    return (
        <nav className="quicksearch__nav">
            {props.items.map((item) => {
                return (
                    <QuickSearchItem
                        key={item.id}
                        {...item}
                        selected={props.selectedItem === item.id}
                    />
                );
            })}
        </nav>
    );
};
